import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS_ENTITY } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
interface IUseFetchPreliminaryInvoicePayers {
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number>;
  limit?: number;
  search?: string;
  id?: string;
  fields?: string[];
}
export const useFetchPreliminaryInvoicePayers = (params: IUseFetchPreliminaryInvoicePayers) => {
  const fetchPreliminaryInvoicePayers = async ({ pageParam = 1 }) => {
    const { relations: partiesRelations, id, extraFilters: filters, ...rest } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      queryString.append(`filter.${key}`, String(value));
    });

    (partiesRelations ?? []).forEach((rel) => queryString.append('relations', rel));

    queryString.append('page', String(pageParam));
    const url = `${API_URLS_ENTITY.PRELIMINARY_INVOICES}/${id}${API_URLS_ENTITY.PAYERS}?${queryString.toString()}`;
    try {
      return await get(url);
    } catch (error) {
      console.error('Error fetching preliminary invoice payers:', error);
      throw new Error(
        (error as { message: string }).message || 'Failed to fetch preliminary invoice payers',
      );
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['preliminary-invoice-payers-list', params],
    queryFn: fetchPreliminaryInvoicePayers,
    getNextPageParam: (lastPage, allPages) => {
      const totalCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedCount = allPages.flatMap((page) => page.data).length;
      return fetchedCount < totalCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  };
};
